import { Controller, type Control, type FieldPath, type FieldValues } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { InputNumber } from 'primereact/inputnumber'
import FormField from '../FormField'
import { resolveFieldError } from '../../../lib/forms/messages'

/**
 * RHF-bağlı sayısal alan (020). `Controller` + PrimeReact `InputNumber` + `FormField`. (Ör. sıra.)
 */
interface FormNumberFieldProps<T extends FieldValues> {
  control: Control<T>
  name: FieldPath<T>
  label: string
  required?: boolean
  full?: boolean
  min?: number
}

export default function FormNumberField<T extends FieldValues>({
  control,
  name,
  label,
  required,
  full,
  min,
}: Readonly<FormNumberFieldProps<T>>) {
  const { t } = useTranslation()
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormField
          label={label}
          htmlFor={name}
          required={required}
          full={full}
          error={resolveFieldError(fieldState.error?.message, t)}
        >
          <InputNumber
            inputId={name}
            value={field.value ?? null}
            onValueChange={(e) => field.onChange(e.value ?? null)}
            onBlur={field.onBlur}
            min={min}
            className={fieldState.error ? 'p-invalid' : undefined}
          />
        </FormField>
      )}
    />
  )
}
